import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { Toaster } from "./components/ui/toaster";
import { TooltipProvider } from "./components/ui/tooltip";
import { useAuthHook } from "./hooks/useAuth";

import Visualise from "./pages/visualise";
import UserDashboard from "./components/Dashboards";
import Dashboard from "./pages/UserDashboard";
import PropertyForm from "./pages/property-form";
import { ValuationProvider } from "./context/ValuationContext";
import ClientPropertyForm from "./pages/client-property-form";
import NotFound from "./pages/not-found";
import LoginPage from "./pages/login";
import RequestAccess from "./pages/requestAccess";
import AuthProvider from "./components/AuthProvider";
import ValuationForm from "./components/valuation-form/ValuationForm";
import { GlobalFormProvider } from "./context/FormContext";
import AboutUs from "./pages/about";
import Team from "./pages/team";
import Resources from "./pages/resources";
import AdminDashboard from "./pages/adminDashboard/Admin";
import ManageUsers from "./pages/adminDashboard/manageUsers";
import ManageReport from "./pages/adminDashboard/manageReports";
import VerifyEmail from "./pages/auth/verifyEmail";
// import SupervisorDashboard from "./components/supervisor/SupervisorDashboard";

// ========== SUPERVISOR ========================
import SupervisorDashboard from "./pages/supervisorDashboard/supervisor";
import SupervisorViewData from "./pages/supervisorDashboard/ViewData";
import SupervisorPropertyDetails from "./components/supervisor/PropertyDetails";
import SupervisorViewReports from "./pages/supervisorDashboard/ViewReports";


// ========== Data Collector ========================
import DataCollectorDashboard from "./components/datacollector/DataCollectorDashboard";
import ClientPropertyDetails from "./components/client/PropertyDetails";

// ========== CLIENT ========================
import ClientDashboard from "./pages/clientDashboard/client";
import ViewData from "./pages/clientDashboard/ViewData";
import ViewReports from "./pages/clientDashboard/ViewReports";

// ========== INSTITUTIONAL CLIENT ==========
import InstitutionalClientDashboard from "./pages/institutionalClientDashboard/InstitutionalClient";
import InstitutionalClientViewData from "./pages/institutionalClientDashboard/ViewData";
import InstitutionalClientPropertyDetails from "./components/institutionalClient/PropertyDetails";
import InstitutionalClientViewReports from "./pages/institutionalClientDashboard/ViewReports";

import PropertyValuation from "./components/valuation/PropertyValuation";
import PropertyDetails from "./components/valuation/PropertyDetails";
import DataCollectorAssignments from "./components/datacollector/DataCollectorAssignments";

// ===== Protected Route Wrapper =====
const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuthHook();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

// ===== Router Setup =====
function AppRouter() {
  return (
    <>
      <AuthProvider>
        <GlobalFormProvider>
          <ValuationProvider>
            <BrowserRouter>
              <Routes>
                {/* === Public Routes === */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/" element={<LoginPage />} />
                <Route
                  path="/property/submit"
                  element={<ClientPropertyForm />}
                />
                <Route path="/request-access" element={<RequestAccess />} />
                <Route path="/" element={<LoginPage />} />
                <Route path="/visualise" element={<Visualise />} />
                <Route path="/valuation" element={<ValuationForm />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/team" element={<Team />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/auth/verify-email" element={<VerifyEmail />} />
                <Route path="/auth/verify-email/:token" element={<VerifyEmail />} />

                {/* === Protected Routes (Requires Auth) === */}
                <Route element={<ProtectedRoute />}>
                  {/* Shared Routes */}
                  <Route path="/dashboard" element={<UserDashboard />} />
                  <Route
                    path="/property/new"
                    element={<ClientPropertyForm />}
                  />
                  <Route path="/property/:id" element={<PropertyForm />} />

                  {/* === Client Routes === */}
                  <Route
                    path="/client-dashboard"
                    element={<ClientDashboard />}
                  />
                  <Route
                    path="/client-dashboard/view-data"
                    element={<ViewData />}
                  ></Route>
                  <Route
                    path="/client-dashboard/view-data/property/:id"
                    element={<ClientPropertyDetails />}
                  />
                  <Route
                    path="/client-dashboard/view-report"
                    element={<ViewReports />}
                  />

                  {/* === Admin Routes === */}
                  <Route path="/admin-dashboard" element={<AdminDashboard />} />
                  <Route
                    path="/admin-dashboard/manage-users"
                    element={<ManageUsers />}
                  />
                  <Route
                    path="/admin-dashboard/manage-report"
                    element={<ManageReport />}
                  />

                  {/* === old Supervisor Routes === */}
                  {/* <Route
                    path="/supervisor-dashboard"
                    element={<UserDashboard />}
                  >
                    <Route index element={<SupervisorDashboard />} />
                    <Route path="property/:id" element={<PropertyDetails />} />
                    <Route
                      path="pending-approval"
                      element={<UserDashboard />}
                    />
                    <Route
                      path="completed-valuations"
                      element={<UserDashboard />}
                    />
                    <Route path="reports" element={<UserDashboard />} />
                    <Route path="manage-users" element={<Dashboard />} />
                    <Route path="system-settings" element={<UserDashboard />} />
                  </Route> */}

                   {/* === supervisor Client Routes === */}

                       {/* === Email Verification Route === */}
                  {/* <Route path="/auth/verify-email" element={<VerifyEmail />} />
                  <Route path="/auth/verify-email/:token" element={<VerifyEmail />} /> */}
                   
                  <Route
                    path="/supervisor-dashboard"
                    element={<SupervisorDashboard />}
                  >
                    <Route index element={<SupervisorDashboard />} />
                    <Route path="property/:id" element={<SupervisorPropertyDetails />} />
                    <Route path="my-properties" element={<SupervisorDashboard />} />
                  </Route>

                  <Route
                    path="/supervisor-dashboard"
                    element={<SupervisorDashboard />}
                  />
                  <Route
                    path="/supervisor-dashboard/view-data"
                    element={<SupervisorViewData />}
                  ></Route>
                  <Route
                    path="/supervisor-dashboard/view-data/property/:id"
                    element={<SupervisorPropertyDetails />}
                  />
                  <Route
                    path="/supervisor-dashboard/view-report"
                    element={<SupervisorViewReports />}
                  />

                  {/* === Client Routes === */}
                  <Route path="/client-dashboard" element={<ClientDashboard />}>
                    <Route index element={<ClientDashboard />} />
                    <Route path="property/:id" element={<PropertyDetails />} />
                    <Route path="my-properties" element={<ClientDashboard />} />
                  </Route>

                  {/* === institutional Client Routes === */}
                  <Route
                    path="/institutional-client-dashboard"
                    element={<InstitutionalClientDashboard />}
                  >
                    <Route index element={<InstitutionalClientDashboard />} />
                    <Route path="property/:id" element={<InstitutionalClientPropertyDetails />} />
                    <Route path="my-properties" element={<InstitutionalClientDashboard />} />
                  </Route>

                  <Route
                    path="/institutional-client-dashboard"
                    element={<InstitutionalClientDashboard />}
                  />
                  <Route
                    path="/institutional-client-dashboard/view-data"
                    element={<InstitutionalClientViewData />}
                  ></Route>
                  <Route
                    path="/institutional-client-dashboard/view-data/property/:id"
                    element={<InstitutionalClientPropertyDetails />}
                  />
                  <Route
                    path="/institutional-client-dashboard/view-report"
                    element={<InstitutionalClientViewReports />}
                  />

                  {/* === Data Collector Routes === */}
                  <Route path="/data-dashboard" element={<UserDashboard />}>
                    <Route index element={<DataCollectorDashboard />} />
                    <Route path="new-valuation" element={<PropertyForm />} />
                    <Route
                      path="my-assignments"
                      element={<DataCollectorAssignments />}
                    />
                    <Route
                      path="property/valuation/:id"
                      element={<PropertyValuation />}
                    />
                  </Route>
                </Route>

                {/* === 404 Not Found === */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </ValuationProvider>
        </GlobalFormProvider>
      </AuthProvider>
    </>
  );
}

// ===== Main App =====
export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <AppRouter />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
